// extracted by mini-css-extract-plugin
export default {"page":"styles_page__vfRiv","watermark":"styles_watermark__OIz21"};